<template>
  <div class="communications-table-wrap">
    <FilterBar
      cookieName="AccountantCommunicationFilterOptionsVue"
      :mainFilters="['SearchFilter']"
      filterBarType="accountant-communications"
      ref="accountant-communications-filterbar"
      @change="setupData"
    />

    <div class="content--inner">
      <overlay-scrollbars class="communications-table-scrollbar">
        <b-table
          :items="communications"
          :fields="fields"
          striped
          hover
          @row-clicked="rowClicked"
          :class="['communications-table gk-table gk-table--responsive gk-table--striped gk-table--hover']"
          :busy="loading"
          show-empty
          table-busy
          ref="communications-table"
        >
          <template #empty="">
            <span class="empty-table-text" v-translate>No communications found.</span>
          </template>

          <template #table-busy="">
            <b-skeleton-table
              :rows="10"
              :columns="4"
              :table-props="{ bordered: false, striped: true }"
              :hide-header="true"
            />
          </template>

          <template #cell(recipients)="data">
            <div class="textwrap">
              <div class="textwrap--content">
                <span class="text-unassigned">{{ $gettext('To: ') }}</span>{{ getFormattedRecipients(data.item.recipients) }}
              </div>
            </div>
          </template>
          <template #cell(subject)="data">
            <div class="textwrap">
              <div class="textwrap--content">
                {{ data.item.subject }} - <span class="text-unassigned">{{ data.item.message }}</span>
              </div>
            </div>
          </template>
          <template #cell(status)="data">
            <div v-if="data.value === 'idle'" class="status-badge status-recurrent">
              {{ $gettext('Scheduled') }}
            </div>
            <div v-else-if="data.value === 'queued'" class="status-badge status-sending">
              {{ $gettext('Queued') }}
            </div>
            <div v-else-if="data.value === 'sent'" class="status-badge status-complete">
              {{ $gettext('Sent') }}
            </div>
            <div v-else-if="data.value === 'failed'" class="status-badge status-overdue">
              {{ $gettext('Failed') }}
            </div>
          </template>

          <template #cell(scheduled_at)="data">
            <div class="">
              {{ data.value | formatDateWithTime }}
            </div>
          </template>

          <template slot="bottom-row" v-if="nextUrl">
            <td :colspan="fields.length" class="table-load-more">
              <GekkoButton
                v-if="nextUrl && !loading"
                @click="handleScroll()"
                id="load_more_button"
                class="text-info"
                variant="link"
                :text="$gettext('Load more communications')"
              />
              <LoadingSpinner v-if="loading" />
            </td>
          </template>
        </b-table>
      </overlay-scrollbars>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import FilterBar from '@/components/list_filters/FilterBar'

import CommunicationService from '@/store/services/communication.service.js'
import GekkoButton from '@/components/GekkoButton'
import LoadingSpinner from '@/components/dashboard/ui/LoadingSpinner'

export default {
  name: 'CommunicationsList',
  components: {
    GekkoButton,
    FilterBar,
    LoadingSpinner,
  },
  data() {
    return {
      communications: [],
      fields: [
        { key: 'recipients', tdClass: 'col-comm-recipients' },
        { key: 'subject', tdClass: 'col-comm-content' },
        { key: 'status', tdClass: 'col-comm-status' },
        { key: 'scheduled_at', tdClass: 'col-comm-scheduled-at' },
      ],
      loading: true,
      currentFilters: null,
      nextUrl: null,
    }
  },
  computed: {
    ...mapGetters({
      currentCompany: 'main/getCurrentCompany',
    }),
  },
  created() {
    this.setupData()
  },
  methods: {
    ...mapActions({
      resendInvitation: 'accountants/resendInvitation',
    }),
    setupData(filters) {
      if (this.$route.params.id) {
        this.getCommunications(this.$route.params.id)
      }
      this.getCommunications(null, filters)
    },
    getCommunications(id, filters) {
      this.loading = true
      this.status = 'loading'

      this.communications = []

      CommunicationService.list(filters)
        .then((response) => {
          this.communications = response.data.results
          this.nextUrl = response.data.next
          this.status = 'success'
        })
        .catch(() => {
          this.status = 'error'
        })
        .finally(() => {
          this.loading = false
        })
    },
    getFormattedRecipients (recipients_list) {
      let recipients = ''
      if (recipients_list.length > 0) {
        recipients = recipients_list.map(recipient => recipient.name).join(', ')
      } else {
        recipients = this.$gettext('everyone')
      }
      return recipients
    },
    refreshData () {
      console.log('refreshData')
      this.$refs['accountant-communications-filterbar'].filtersChanged()
    },
    rowClicked(item) {
      this.$router.push({
        name: 'CommunicationDetail',
        params: {
          communication_id: item.id,
        },
      })
    },
  },
}
</script>

<style lang="scss">
.communications-table-wrap {
  .os-host.communications-table-scrollbar {
    min-height: 360px;
  }
  &.table-on-modal {
    .os-host.communications-table-scrollbar {
      height: 300px !important;
      max-height: 300px;
      .os-content {
        padding: 0 !important;
      }
    }
  }
  .communications-table {
    .col-comm-recipients {
      text-align: left;
      width: 20%;
    }
    .col-comm-content {
      text-align: left;
      width: 50%;
      min-width: 200px;
    }
    .col-comm-status {
      text-align: right;
      width: 10%;
    }
    .col-comm-scheduled-at {
      width: 10%;
      white-space: nowrap;
      text-align: right;
    }
  }
  .textwrap {
    width: 100%;
    min-width: 200px;
    display: grid;
    &--content {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      max-width: 95%;
    }
  }
}
</style>
